import { ReactNode, useEffect, useState } from 'react';

import { UnorderedList } from '@r1-frontend/ui-react/components/List';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { RoundedBlock } from '@r1-frontend/ui-react/experimental/blocks';
import BaseSpeedLine, { TBaseSpeedLineItem, TBaseSpeedLineProps } from '@r1-frontend/ui-react/organisms/SpeedLine/BaseSpeedLine';
import { TArrayTwoOrMore } from '@r1-frontend/shared/types/Array';

import * as ST from './SpeedLineWithDescription.styled';

export type TSpeedLineItemWithDescription = TBaseSpeedLineItem & {
    alias: string,
    title: string,
    descriptionList: string[],
    price: number,
}

export type TSpeedLineWithDescription = TBaseSpeedLineProps & {
    items: TArrayTwoOrMore<TSpeedLineItemWithDescription>,
    title?: string | ReactNode,

    /**
     * This is a forced decision at the designer's request.
     * It is not good, but it has fast implementation.
     * If designers ask about other implementations, we should arrange a meeting. :facepalm:
     *
     * I'm sorry guys, really.
     */
    experimentalModeForConstructor?: boolean,
}

const SpeedLineWithDescription = (
    {
        items,
        title = 'Выберите нужную скорость',
        startDot = 0,
        onSelect,

        experimentalModeForConstructor = false,

        ...props
    }: TSpeedLineWithDescription,
): JSX.Element => {
    const [selectedItem, setSelectedItem] = useState(startDot);

    useEffect(() => {
        setSelectedItem(startDot);
    }, [items]);

    const handleOnSelect = (id: number) => {
        setSelectedItem(id);
        onSelect(id);
    };

    return (
        <ST.SpeedLineWithDescriptionWrapper>
            <RoundedBlock>
                <ST.HeaderWrapper>
                    <H4 as={'h2'} $withIndent={false}>{title}</H4>
                </ST.HeaderWrapper>
                <BaseSpeedLine
                    items={items}
                    startDot={selectedItem}
                    onSelect={handleOnSelect}
                    experimentalModeForConstructor={experimentalModeForConstructor}
                    {...props}
                />
                <UnorderedList>
                    {items[selectedItem].descriptionList &&
                        items[selectedItem].descriptionList.map(description => (
                            <Paragraph4
                                as={'li'}
                                key={`speedLine_description_${description}}`}
                                dangerouslySetInnerHTML={{ __html: description }}
                            />
                        ))
                    }
                </UnorderedList>
            </RoundedBlock>
        </ST.SpeedLineWithDescriptionWrapper>
    );
};

export default SpeedLineWithDescription;
